import _objectSpread from "/home/vsts/work/1/s/src/Soderberg.Web/ClientApp/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import platform from './node/index.js';
import * as utils from './common/utils.js';
export default _objectSpread(_objectSpread({}, utils), platform);